export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.459.101l-7.248 7.79c-.42.452-.076 1.154.565 1.154h2.102L4.03 15.593c-.147.3.279.556.511.306l7.249-7.791c.42-.451.075-1.153-.566-1.153H9.122L11.97.407c.147-.3-.279-.556-.511-.306z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};